import React from 'react';
import { Button, Menu, Plus } from '@opendate-app/setlist';

const formatPrice = (price) => {
  if (price === null || price === undefined || price === '') return null;
  const num = Number(price);
  if (Number.isNaN(num)) return null;
  return `$${num % 1 === 0 ? num : num.toFixed(2)}`;
};

const byName = (records) =>
  (records || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''));

const describe = (kind, price) => [kind, formatPrice(price)].filter(Boolean).join(' · ');

const AddItemMenu = ({
  onSelect,
  confirm,
  team,
  ticketTypes = [],
  addOns = [],
  memberships = [],
  seatingChartEvents = [],
  canAddDonation,
  canAddSeatedAdmissionChart,
  canAddSeatedAddOnChart
}) => {
  const sections = [
    byName(ticketTypes.filter((t) => !t.seating_chart_category_key)).map((tt) => ({
      key: `ticket-${tt.id}`,
      label: tt.name,
      description: describe('Ticket', tt.price),
      onClick: () => onSelect({ item_type: 'TicketType', item_id: tt.id })
    })),
    byName(addOns.filter((a) => !a.seating_chart_category_key)).map((ao) => ({
      key: `add-on-${ao.id}`,
      label: ao.name,
      description: describe('Add-on', ao.price),
      onClick: () => onSelect({ item_type: 'AddOn', item_id: ao.id })
    })),
    [
      canAddSeatedAdmissionChart && {
        key: 'seated-admission-chart',
        label: 'Seated Admission Chart',
        description: 'Seating chart',
        onClick: () => onSelect({ seatsio_event_id: confirm.seatsio_event_id })
      },
      canAddSeatedAddOnChart && {
        key: 'seated-add-on-chart',
        label: 'Seated Add-on Chart',
        description: 'Seating chart',
        onClick: () => onSelect({ add_on_seatsio_event_id: confirm.add_on_seatsio_event_id })
      },
      ...byName(seatingChartEvents).map((sce) => ({
        key: `seating-chart-event-${sce.id}`,
        label: sce.name,
        description: 'Seating chart',
        onClick: () => onSelect({ item_type: 'SeatingChartEvent', item_id: sce.id })
      }))
    ].filter(Boolean),
    canAddDonation ? [{
      key: 'donation',
      label: 'Make a donation',
      description: 'Donation',
      onClick: () => onSelect({ enable_donation: true })
    }] : [],
    team && team.can_access_memberships ? byName(memberships).map((mp) => ({
      key: `membership-${mp.id}`,
      label: mp.name,
      description: 'Membership',
      onClick: () => onSelect({ item_type: 'MembershipProduct', item_id: mp.id })
    })) : []
  ].filter((section) => section.length > 0);

  const items = sections.length > 0
    ? sections.flatMap((section, i) => (i === 0 ? section : [{ divider: true, key: `divider-${i}` }, ...section]))
    : [{ key: 'empty', label: 'No items available to add.', disabled: true }];

  return (
    <Menu
      placement="bottom-start"
      minWidth={260}
      items={items}
      trigger={
        <Button variant="link-color" size="sm" icon={Plus}>
          Add item
        </Button>
      }
    />
  );
};

export default AddItemMenu;
